import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import { scrollToTop } from '@utils/helpers';

/**
 * Layout Component
 * Main layout wrapper with header and footer
 */
const Layout = ({ children, showHeader = true, showFooter = true }) => {
  const location = useLocation();

  // Scroll to top on route change
  useEffect(() => {
    scrollToTop();
  }, [location.pathname]);

  return (
    <div className="flex flex-col min-h-screen">
      {/* Header */}
      {showHeader && <Header />}

      {/* Main Content */}
      <main className="flex-grow">
        {children}
      </main>

      {/* Footer */}
      {showFooter && <Footer />}

      {/* Scroll to Top Button */}
      <ScrollToTopButton />
    </div>
  );
};

/**
 * Scroll to Top Button
 * Floating button that appears on scroll
 */
const ScrollToTopButton = () => {
  const [isVisible, setIsVisible] = React.useState(false);

  // Show button when page is scrolled up to given distance
  const toggleVisibility = () => {
    if (window.pageYOffset > 300) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  return (
    <button
      onClick={() => scrollToTop()}
      className={`
        fixed bottom-8 right-8 z-30
        p-3 rounded-full
        bg-bukawa-secondary text-white
        shadow-lg hover:shadow-xl
        transition-all duration-300
        ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10 pointer-events-none'}
      `}
      aria-label="Scroll to top"
    >
      <svg
        className="h-6 w-6"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path d="M5 10l7-7m0 0l7 7m-7-7v18" />
      </svg>
    </button>
  );
};

export default Layout;